<div class="grey-text" translate>
  PHONE.AGENT_ONLINE.LONGEST_DESCRIPTION
</div>
